// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__25uhj","subheader":"ReorderModal_subheader__1uOVo","listWrap":"ReorderModal_listWrap__3mZ3r"};